/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Deploy_Desc6Inputs */

const en_svc_mvp_sprint_deploy_desc6 = /** @type {(inputs: Svc_Mvp_Sprint_Deploy_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live URL from week one, with analytics and error tracking wired in.`)
};

const ar_svc_mvp_sprint_deploy_desc6 = /** @type {(inputs: Svc_Mvp_Sprint_Deploy_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رابط مباشر من الأسبوع الأول، مع تحليلات وتتبع أخطاء مربوطة.`)
};

const bn_svc_mvp_sprint_deploy_desc6 = /** @type {(inputs: Svc_Mvp_Sprint_Deploy_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রথম সপ্তাহ থেকেই লাইভ URL, অ্যানালিটিক্স আর এরর ট্র্যাকিং সংযুক্ত।`)
};

const de_svc_mvp_sprint_deploy_desc6 = /** @type {(inputs: Svc_Mvp_Sprint_Deploy_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-URL ab Woche eins, mit verdrahtetem Analytics und Fehlertracking.`)
};

const es_svc_mvp_sprint_deploy_desc6 = /** @type {(inputs: Svc_Mvp_Sprint_Deploy_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL en vivo desde la primera semana, con analítica y seguimiento de errores integrados.`)
};

const fr_svc_mvp_sprint_deploy_desc6 = /** @type {(inputs: Svc_Mvp_Sprint_Deploy_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL en ligne dès la première semaine, avec analytique et suivi d'erreurs câblés.`)
};

const pt_svc_mvp_sprint_deploy_desc6 = /** @type {(inputs: Svc_Mvp_Sprint_Deploy_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL no ar desde a primeira semana, com análise e rastreio de erros ligados.`)
};

const zh_svc_mvp_sprint_deploy_desc6 = /** @type {(inputs: Svc_Mvp_Sprint_Deploy_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`第一周就有线上 URL，分析和错误追踪全部接好。`)
};

const tr_svc_mvp_sprint_deploy_desc6 = /** @type {(inputs: Svc_Mvp_Sprint_Deploy_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlk haftadan canlı URL, analitik ve hata takibi bağlı.`)
};

const ru_svc_mvp_sprint_deploy_desc6 = /** @type {(inputs: Svc_Mvp_Sprint_Deploy_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Живой URL с первой недели, с подключённой аналитикой и трекингом ошибок.`)
};

const pl_svc_mvp_sprint_deploy_desc6 = /** @type {(inputs: Svc_Mvp_Sprint_Deploy_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Żywy URL od pierwszego tygodnia, ze spiętą analityką i trackingiem błędów.`)
};

/**
* | output |
* | --- |
* | "Live URL from week one, with analytics and error tracking wired in." |
*
* @param {Svc_Mvp_Sprint_Deploy_Desc6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_deploy_desc6 = /** @type {((inputs?: Svc_Mvp_Sprint_Deploy_Desc6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Deploy_Desc6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_deploy_desc6(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_deploy_desc6(inputs)
	if (locale === "de") return de_svc_mvp_sprint_deploy_desc6(inputs)
	if (locale === "es") return es_svc_mvp_sprint_deploy_desc6(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_deploy_desc6(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_deploy_desc6(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_deploy_desc6(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_deploy_desc6(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_deploy_desc6(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_deploy_desc6(inputs)
	return en_svc_mvp_sprint_deploy_desc6(inputs)
});
export { svc_mvp_sprint_deploy_desc6 as "svc_mvp-sprint_DEPLOY_desc" }